import { opportunityTimingStage, type DashboardSummary, type Contact, type OutreachSequence, type EmailTemplate, type CaseStudy, type Company, type Mission, type Opportunity } from '@client-outreach/shared';
import type { AppDataSnapshot, AppRepository } from './repository';
import { DEMO_DATA } from './demo';

const clone = <T,>(value:T):T => JSON.parse(JSON.stringify(value));

export class LocalRepository implements AppRepository {
  mode = 'demo' as const;
  ownerUid = 'demo-user';
  private data: AppDataSnapshot = clone(DEMO_DATA);

  async loadAll(): Promise<AppDataSnapshot> { return clone(this.data); }

  async dashboard(snapshot = this.data): Promise<DashboardSummary> {
    const sequences=snapshot.sequences.filter(x=>!x.archived);
    return {
      readyToContact: sequences.filter(x => x.stage === 'queue').length,
      scheduled: sequences.filter(x => x.stage === 'scheduled').length,
      awaitingResponse: sequences.filter(x => x.stage === 'sent' && x.outcome === 'awaiting-response').length,
      openingsSoon: snapshot.opportunities.filter(x => opportunityTimingStage(x) === 'opening-soon').length,
      followUpsDue: sequences.filter(x=>x.followUpDueAt&&!x.followUpSentAt&&Date.parse(x.followUpDueAt)<=Date.now()).length,
    };
  }

  async upsertCompany(row:Company){this.data.companies=upsert(this.data.companies,row);return clone(row);}
  async upsertContact(row: Contact) { this.data.contacts = upsert(this.data.contacts, row); return clone(row); }
  async upsertOpportunity(row:Opportunity){this.data.opportunities=upsert(this.data.opportunities,row);return clone(row);}
  async upsertMission(row:Mission){this.data.missions=upsert(this.data.missions,row);return clone(row);}
  async deleteMission(id:string){this.data.missions=this.data.missions.filter(x=>x.id!==id);}
  async upsertSequence(row: OutreachSequence) { this.data.sequences = upsert(this.data.sequences, row); return clone(row); }
  async deleteSequence(id:string){this.data.sequences=this.data.sequences.filter(x=>x.id!==id);}
  async upsertTemplate(row: EmailTemplate) { this.data.templates = upsert(this.data.templates, row); return clone(row); }
  async deleteTemplate(id:string){this.data.templates=this.data.templates.filter(x=>x.id!==id);}
  async upsertCaseStudy(row: CaseStudy) { this.data.caseStudies = upsert(this.data.caseStudies, row); return clone(row); }
  async deleteCaseStudy(id:string){this.data.caseStudies=this.data.caseStudies.filter(x=>x.id!==id);}
}

function upsert<T extends {id:string}>(rows:T[], row:T):T[] {
  const i = rows.findIndex(x => x.id === row.id);
  if (i < 0) return [...rows, row];
  const next = rows.slice(); next[i] = row; return next;
}
